/**
 * Lightweight Authentication State Hook
 *
 * Single Responsibility: Provide read-only auth state access
 * Separation of Concerns: Only state, no actions or side effects
 * DRY: Reuses centralized context without additional overhead
 */

import { useAuthContext } from "@/contexts/auth-context";

/**
 * Lightweight hook for components that only need to read auth state
 * Use this instead of useAuth() when you don't need actions
 */
export function useAuthState() {
  const { state } = useAuthContext();

  return {
    isLoading: state.auth.isLoading,
    isAuthenticated: state.auth.isAuthenticated,
    user: state.auth.user,
    sessionStatus: state.auth.sessionStatus,
    isInPublicOrganization: state.publicOrg.isInPublicOrganization,
  };
}
